module.exports = __webpack_public_path__ + "static/media/squirrel4.472b6044.jpg";